export const financialResInitialData = {
  name: '',
  phone: '',
  street: '',
  city: '',
  state: { id: '', name: '', children: null },
  zip: '',
};
